import React from 'react';
import pic4 from '../assets/pic4.png'
import './home.css'
import PrimaryctaLong from '../components/common/primary cta long';
import SecondaryctaLong from '../components/common/seconday cta long';
import { Link } from 'react-router-dom';
import Settings from '../components/common/settings';
import { useState } from 'react';

const Home = () => {
     const [settingsOpen, setSettingsOpen] = useState(false);
     const currentLevel = localStorage.getItem('currentLevel');


    return ( 
          <main className='homepage-container'>
            {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
               <section className='container-splash-page'>
                   <div className='game-title-logo'>
                       <h1 className='game-name'>Desert Treasure Run</h1>
                         <h1 className='text-effect'>Desert Treasure Run</h1>
                   </div>
                   <div className='progress-bar-splash2'>
                       <div className='progess-line-splash2'></div>
                   </div>
               </section>

               <div className='container-ctas-homepage'>
               <Link
               to={
                currentLevel === '5'
               ? '/level5unlocked'
                :currentLevel === '4'
                    ? '/level4unlocked'
               :currentLevel === '3'
                    ? '/level3unlocked'
                    : currentLevel === '2'
                    ? '/level2unlocked'
                    : '/levels'
               }
               className="home-link"
               >
                <PrimaryctaLong title='Play Now'/>
                </Link>
                <SecondaryctaLong title='Settings'  onClick={() => setSettingsOpen(true)}/>
                <Link to='/characters'  className='home-link'>
                     <SecondaryctaLong title='Characters'/>
                </Link>
               </div>
   
               <img src={pic4} alt='charcter' className='character-spalsh-page2'></img>

             
          </main>
     );
}
 
export default Home;